module.exports = __webpack_public_path__ + "static/media/6.6f79228f.png";